module.exports = __webpack_public_path__ + "static/League_Gothic-webfont-036cfa9c2ade08c1a4ee234526201dc8.eot";